import { Injectable } from '@angular/core';
import { HttpHeaders, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { of, throwError } from "rxjs";
import { retry, catchError, map, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CommonServiceService } from 'src/app/common-service.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private route: Router,
    private toastService: ToastrService,
    private commonService : CommonServiceService
  ) {}
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if(!req.url.includes('notifications'))
    this.commonService.loadingSpinnerCall(true)

    if (req.headers.get('skip') === 'true') {
      req = req.clone({
        headers: new HttpHeaders({})
      });
    } else {
      const authorization = localStorage.getItem('authorization');
      if (!authorization) {
        this.route.navigateByUrl('/admin');
      } else {
        req = req.clone({
          headers: new HttpHeaders({
            'authorization': `Bearer ${authorization}`,
          })
        });
      }
    }
    // Sending request***
    return next.handle(req).pipe(
      catchError((error) => {
        this.commonService.loadingSpinnerCall(false);
        let handled: boolean = false;
        if (error instanceof HttpErrorResponse) {
          if (error.error instanceof ErrorEvent) {
            console.error("Error Event");
          } else {
            console.log(`error status : ${error.status} ${error.statusText}`);
            switch (error.status) {
              case 400: //login
                // this.authservice.setErrorOccured();
                handled = true;
                break;
              case 401: //login
                console.log("401codeissue", error);
                console.log("401codeissue", error.error);
                handled = true;
                if (
                  error.error.error == "Token has been expired" ||
                  error.error.error == "You are unauthorized to make this request."
                ) {
                  let lang = localStorage.getItem('lang')|| 'en';
                  localStorage.clear();
                  sessionStorage.clear();
                  localStorage.setItem('lang',lang)
                }
                break;
              case 403: //forbidden
                console.log(`redirect to login`);
                handled = true;
                break;
              case 404: //login
                console.log(`Not Found Request`);
                handled = true;
                break;
              case 422: //forbidden
                console.log(`redirect to login`);
                handled = true;
                break;
              case 500: //forbidden
                console.log(`Server Error`);
                handled = true;
                break;
            }
            // console.log(error.error.error.message)

            if (error.error.error.message){
              this.toastService.error(error.error.error.message);
            }
              else{
                 this.toastService.error(error.error.error);
              }
          }
        } else {
          console.error("Other Unhandled Errors from server");
        }
        if (handled) {
          return of(error);
        } else {
          return throwError(error);
        }
      })
    );
  }

}
